const messages = {
    nl: {
        pages: {
            tokenInvalid: {
                title: 'Link is niet (meer) geldig.',
                description: 'De link die je hebt gebruikt is niet meer geldig. De link vervalt 48 uur na het versturen van de mail.',
                solution: 'Vraag een nieuwe link aan met de wachtwoord vergeten functie.',
                button: 'wachtwoord vergeten'
            },
            login: {
                title: 'Hey hallo!',
                caution: 'Let op!',
                instructions: 'Het TOPAnimation account is vernieuwd. Je krijgt nieuwe inloggegevens zodra je een nieuw document van ons krijgt. Wil je eerder toegang? Mail even ',
                rememberMe: 'Ingelogd blijven',
                passwordForgotten: 'Wachtwoord vergeten?',
                login: 'Login',
            },
            campingsMail: {
                pageHeader: 'Stuur een email',
                modal: {
                    title: 'Email variables',
                    show: 'Toon email variabelen'
                },
                sections: {
                    template: {
                        changeTemplateButton: 'wijzig template',
                        useThisTemplateButton: 'Gebruik deze template',
                        withoutTemplateButton: 'Doorgaan zonder template'
                    },
                    meta: {
                        title: 'Mail gegevens',
                        description: 'De meest belangrijke gegevens bij het versturen van een mailtje.',
                        to: 'Aan',
                        fromName: 'Van (naam)',
                        fromEmail: 'Van (e-mail)',
                        cc: 'CC',
                        bcc: 'BCC',
                        subject: 'Onderwerp'
                    },
                    content: {
                        title: 'E-mail inhoud',
                        description: 'Gebruik tags om je mail nóg persoonlijker te maken.'
                    }
                }
            },
            campingCreate: {
                pageHeader: 'Stuur een email',
                sections: {
                    main: {
                        title: 'Maak een camping aan',
                        description: ''
                    },
                    address: {
                        title: 'Bezoek adres',
                        description: 'De adres gegevenas van het bezoekadres'
                    },
                    sarl_address: {
                        title: 'SARL adres',
                        description: 'De adres gegevenas van het SARL adres'
                    }
                }
            },
            campingsItinerary: {
                pageHeader: 'Stuur reisgegevens naar de camping',
                sections: {
                    meta: {
                        title: 'Mail gegevens',
                        description: 'De meest belangrijke gegevens bij het versturen van een mailtje.',
                        to: 'Aan',
                        subject: 'Onderwerp'
                    },
                    content: {
                        title: 'E-mail inhoud',
                        description: 'Je kunt je tekst nog even aanpassen als je wilt.'
                    }
                }
            },
            employeesMail: {
                pageHeader: 'Stuur een email',
                modal: {
                    title: 'Email variables',
                    show: 'Toon email variabelen'
                },
                sections: {
                    template: {
                        changeTemplateButton: 'wijzig template',
                        useThisTemplateButton: 'Gebruik deze template',
                        withoutTemplateButton: 'Doorgaan zonder template'
                    },
                    meta: {
                        title: 'Mail gegevens',
                        description: 'De meest belangrijke gegevens bij het versturen van een mailtje.',
                        to: 'Aan',
                        fromName: 'Van (naam)',
                        fromEmail: 'Van (e-mail)',
                        cc: 'CC',
                        bcc: 'BCC',
                        subject: 'Onderwerp'
                    },
                    content: {
                        title: 'E-mail inhoud',
                        description: 'Gebruik tags om je mail nóg persoonlijker te maken.'
                    }
                }
            },
            employeesIndex: {
                title: 'Medewerkers',
                queryCount: 'Geen medewerkers gevonden | Één medewerker gevonden | {count} medewerkers gevonden',
                photolistConfirmationModal: {
                    title: 'Genereer fotolijst',
                    description: 'Je gaat een fotolijst maken van één medewerker. In de volgende stap kun je selecteren welke velden je wilt tonen in de lijst.|Je gaat een fotolijst maken van {count} medewerkers. In de volgende stap kun je selecteren welke velden je wilt tonen in de lijst.',
                    confirmText: 'Genereer fotolijst'
                },
                createUserAccountsConfirmationModal: {
                    title: 'Maak gebruikersaccount voor deze gebruiker|Maak {count} gebruikersaccounts',
                    description: "Je maakt gebruikersaccounts aan voor de geselecteerde medewerkers die er nog geen hebben.",
                    confirmText: 'maak gebruikersaccount|maak {count} gebruikersaccounts'
                },
                scopes: {
                    active: 'Actief',
                    archive: 'Inactief',
                    declarationOfIntentSigned: 'Int. verkl. getekend',
                    declarationOfIntentSend: 'Int. verkl. gestuurd',
                    contractSend: 'Contract verst.',
                    missingDocuments: 'Missende docs',
                    readyForSeason: 'Klaar v. seizoen',
                    readyForMatchingBoard: 'Klaar v. matchingbord',
                    jobApplicationInFourteenDays: 'Gespr. in 14dgn',
                    sixWeekCall: 'Bellen 6 wkn',
                    twelveWeekCall: 'Bellen 12 wkn',
                    substitute: 'Invallers',
                    actionNeeded: 'Actie nodig',
                }
            },
            employeesShow: {
                title: 'Medewerkers',
                allEmployees: 'Alle medewerkers',
                tabs: {
                    general: 'Algemeen',
                    application: 'Sollicitatie',
                    contract: 'Contracten',
                    animationWork: 'Animatiewerk',
                    document: 'Documenten',
                    travel: 'Reis',
                    history: 'Geschiedenis',
                    notes: 'Notities',
                    education: 'Opleidingen en ervaringen'
                },
                actions: {
                    title: 'Acties',
                    contractNL: 'Maak contract - NL',
                    contractFR: 'Maak contract - FR',
                    profileFR: 'Profiel PDF - FR',
                    signDeclarationOfIntent: 'Intentieverklaring laten ondertekenen',
                    signPayrollTaxForm: 'Loonheffingsformulier laten ondertekenen',
                    signLearningAgreement: 'Leerovereenkomst laten ondertekenen',
                    createUserAccount: 'Maak gebruikers account',
                    seeUserAccount: 'Zie gebruikers account',
                    sendAnEmail: 'Verstuur een email',
                    goToAirtable: 'Ga naar Airtable',
                    sendToWhatsapp: 'Verstuur een WhatsApp bericht',
                    addToEmployes: 'Voeg toe aan Employes',
                },
                sections: {
                    basicInfo: {
                        title: 'Algemeen',
                        description: 'Dit zijn de persoonlijke (basis)gegevens van de medewerker.'
                    },
                    address: {
                        title: 'Adres',
                        description: 'Hier vinden we het adres.'
                    },
                    emergencyContact: {
                        title: 'Noodcontacten',
                        description: 'De contactpersonen in geval van nood.',
                        emptyMessage: 'Voeg één of meer contactpersonen toe.',
                    },
                    profileImage: {
                        title: 'Profielfoto',
                        description: "Upload een foto van de medewerker"
                    },
                    application: {
                        title: 'Sollicitatie datum/tijd',
                        description: "Informatie over de sollicitatie"
                    },
                    historyExperience: {
                        title: 'Contact momenten',
                        description: 'Informatie over de contact momenten'
                    },
                    history: {
                        title: 'Geschiedenis',
                        description: 'Wat er gebeurd is met deze gebruiker binnen de app.'
                    },
                    travel: {
                        title: 'Reisvoorkeuren',
                        description: 'Reisgegevens van de medewerker'
                    },
                    other: {
                        title: 'Overig',
                        seasons: 'Seizoenen'
                    },
                    finance: {
                        title: 'Financiele informatie',
                    },
                    personalProcess: {
                        title: 'Persoonlijk proces',
                    },
                    languageProficiency: {
                        title: 'Talen kennis',
                    },
                    education: {
                        title: 'Opleidingen',
                        description: 'Alle opleidingen die deze persoon heeft gevolgd.',
                    },
                    experience: {
                        title: 'Ervaringen',
                    },
                    workExperience: {
                        title: 'Werk ervaring',
                        description: 'De werkervaring die deze persoon heeft.',
                        add: 'Voeg wat werkervaringen toe.',
                    },
                    availability: {
                        title: 'Beschikbaarheid',
                    },
                    trainingAndReunion: {
                        title: 'Training en reunie',
                    },
                    topMeetup: {
                        title: 'TOP Meetup',
                    },
                    preferences: {
                        title: 'Voorkeuren',
                    },
                    documents: {
                        title: 'Documenten',
                        description: 'Alle documenten die relevant zijn bij deze medewerker.',
                    },
                    notes: {
                        title: 'Notities',
                        description: 'Aantekeningen over deze gebruiker.'
                    },
                    contracts: {
                        title: 'Contracten',
                        downloadInfoDoc: 'Download informatie document'
                    }
                }
            },
            mailtemplatesIndex: {
                pageHeader: '',
                deleteConfirmationModal: {
                    title: 'Delete template \'{templateName}\'',
                    description: 'You will delete the entire template from the system. This action can not be undone',
                    confirmText: 'delete template'
                }
            },
            mailtemplatesCreate: {
                pageHeader: '',
                sections: {
                    meta: {
                        title: 'Template settings',
                        description: 'This are the default settings of the template. They can be changed when you are sending an email.'
                    }
                }
            },
            mailtemplatesEdit: {
                pageHeader: 'Edit mailtemplate',
                sections: {
                    meta: {
                        title: 'Template settings',
                        description: 'This are the default settings of the template. They can be changed when you are sending an email.'
                    }
                }
            },
            contractShow: {
                pageHeader: 'Contract',
                sections: {
                    employee: {
                        title: 'Medewerker',
                        description: 'Dit is de medewerker in kwestie.'
                    },
                    contract: {
                        title: 'Contract',
                        description: 'Meer informatie over het specifieke contract vind je hier.',
                        createContractWithSignRequest: 'SignRequest versturen',
                        createContractWithoutSignRequest: 'Contract doc. aanmaken',
                        pushContractToEmployes: 'Aan employes toevoegen'
                    }
                }
            },
            contractEdit: {
                pageHeader: 'Contract',
                sections: {
                    main: {
                        title: 'Contractdetails',
                        description: 'Hier kun je details van dit contract wijzigen.'
                    },
                }
            },
            contractCreate: {
                sectionTitle: '{type}',
                sectionDescription: 'Vul de benodigde informatie in om een {type} toe te voegen voor {fullName}'
            },
            contractsIndex: {
                title: 'Contracten',
                queryCount: 'Geen contracten gevonden | Één contract gevonden | {count} contracten gevonden',
                scopes: {
                    all: 'Alle',
                    notSigned: 'Nog niet getekend',
                    signed: 'Getekend',
                    signedEmployesFalse: 'Getekend + Employes',
                    expiresInFortyFiveDays: 'Loopt af binnen 45 dagen',
                    expired: 'Verlopen contracten',
                }
            },


            employeesCreate: {
                formHeader: 'Gegevens nieuwe medewerker',
                sections: {
                    main: {
                        title: 'Algemeen',
                        description: 'We hebben deze gegevens nodig om een nieuwe medewerker toe te voegen. De overige informatie kun je in de volgende stappen toevoegen.'
                    }
                }
            },
            employeesEditBasicinfo: {
                formHeader: 'Bewerk werknemer',
                sections: {
                    basicInfo: {
                        title: 'Algemeen',
                        description: 'Algemene informatio over deze werknemer.'
                    },
                    birth: {
                        title: 'Geboorte'
                    }
                }
            },
            employeesEditAddress: {
                formHeader: 'Bewerk werknemer',
                sections: {
                    main: {
                        title: 'Adres',
                        description: 'Dit is het adres waar onze werknemer primair woont.'
                    }
                }
            },
            employeesEditOther: {
                formHeader: 'Bewerk werknemer',
                sections: {
                    main: {
                        title: 'Overig'
                    }
                }
            },
            employeesEditEmergencycontacts: {
                formHeader: 'Bewerk werknemer',
                sections: {
                    main: {
                        title: 'Noodcontacten',
                        description: 'Wie kunnen we bellen in geval van nood?'
                    }
                },
                errorMessage: 'Controleer alstublieft je ingevulde gegevens en probeer het opnieuw.'
            },
            employeesEditApplication: {
                formHeader: 'Bewerk werknemer sollicitatie informatie',
                sections: {
                    main: {
                        title: 'Algemene informatie',
                        description: 'Algemene informatie over het solicitatiegesprek'
                    }
                }
            },
            employeesEditAppearance: {
                formHeader: 'Bewerk werknemer uiterlijk overkomen',
                sections: {
                    main: {
                        title: 'Uiterlijk',
                        description: 'Vertel ons wat je vindt van de kanidaat na het interview.'
                    }
                }
            },
            employeesEditIndependence: {
                formHeader: 'Bewerk werknemer zelfstandigheid',
                sections: {
                    main: {
                        title: 'Zelfstandigdheid',
                        description: 'Vertel ons wat je vindt van de kanidaat na het interview.'
                    }
                }
            },
            employeesEditFlexibility: {
                formHeader: 'Bewerk werknemer flexibiliteit',
                sections: {
                    main: {
                        title: 'Flexibiliteit',
                        description: 'Vertel ons wat je vindt van de kanidaat na het interview.'
                    }
                }
            },
            employeesEditCampingtype: {
                formHeader: 'Bewerk werknemer camping type',
                sections: {
                    main: {
                        title: 'Camping type',
                        description: 'Vertel ons wat je vindt van de kanidaat na het interview.'
                    }
                }
            },
            employeesEditNotes: {
                formHeader: 'Bewerk werknemer notities',
                sections: {
                    main: {
                        title: 'Notities',
                        description: 'Wil je nog iets bijzonders toevoegen over deze kandidaat?'
                    }
                }
            },
            employeeAddNote: {
                formHeader: 'Voeg geschiedenis notitie toe',
                sections: {
                    main: {
                        title: 'Notitie',
                        description: 'Voeg een notitie toe over deze medewerker.'
                    }
                }
            },
            employeesEditSecondaryeducation: {
                formHeader: 'Talenknobbel info bewerken',
                sections: {
                    frenchLanguage: {
                        title: 'Franse taal',
                        description: 'Wat is het algemene Frans niveau? '
                    },
                    otherLanguages: {
                        title: 'Andere talen'
                    }
                }
            },
            employeesEditEducations: {
                formHeader: 'Bewerk werknemer opleidingen',
                sections: {
                    main: {
                        title: 'Opleiding',
                        description: 'Alle opleidingen die de persoon heeft gedaan.'
                    }
                },
                errorMessage: 'Controleer alstublieft je ingevulde gegevens en probeer het opnieuw.'
            },
            employeesEditWorkexperience: {
                formHeader: 'Bewerk werknemer werkervaringen',
                sections: {
                    main: {
                        title: 'Werkervaring',
                        description: 'Alle werkervaringen die de persoon heeft.'
                    }
                },
                errorMessage: 'Controleer alstublieft je ingevulde gegevens en probeer het opnieuw.'
            },
            employeesEditPersonnelprocess: {
                formHeader: 'Persoonlijk proces',
                sections: {
                    passport: {
                        title: 'Paspoort'
                    },
                    substitute: {
                        title: 'Invaller'
                    },
                    educationAgreement: {
                        title: 'Leerovereenkomst'
                    },
                    variousOptions: {
                        title: 'Overige opties'
                    }
                }
            },
            employeesEditFormerEmployee: {
                formHeader: 'Oud medewerker',
                sections: {
                    formerEmployee: {
                        title: 'Oud medewerker'
                    },
                }
            },
            employeesEditFinance: {
                formHeader: 'Financieel',
                sections: {
                    finance: {
                        title: 'Financiële informatie'
                    }
                }
            },
            employeesEditAvailability: {
                formHeader: 'Beschikbaarheid',
                sections: {
                    main: {
                        title: 'Beschikbaarheid'
                    }
                }
            },
            employeesEditTrainingreunion: {
                formHeader: 'Training en reunie',
                sections: {
                    main: {
                        title: 'Training en reunie'
                    }
                }
            },
            employeesEditTopMeetup: {
                formHeader: 'TOP Meetup',
                sections: {
                    main: {
                        title: 'TOP Meetup'
                    }
                }
            },
            employeesEditExperience: {
                formHeader: 'Ervaring',
                sections: {
                    main: {
                        title: 'Ervaring'
                    }
                }
            },
            employeesEditTravel: {
                formHeader: 'Reis',
                sections: {
                    main: {
                        title: 'Reisvoorkeuren',
                        description: 'Reisgegevens van de medewerker'
                    }
                }
            },
            employeesEditPreferences: {
                formHeader: 'Voorkeuren',
                sections: {
                    main: {
                        title: 'Voorkeuren'
                    }
                }
            },

            profileShow: {
                title: 'Profiel',
                tabs: {
                    general: 'Algemeen',
                    travel: 'Reis',
                    documents: 'Documenten'
                },
                sections: {
                    basicInfo: {
                        title: 'Algemeen',
                        description: 'Dit zijn je persoonlijke gegevens.'
                    },
                    address: {
                        title: 'Adres',
                        description: 'Zorg er asjeblieft voor dat je adres volledig en correct is.'
                    },

                    password: {
                        title: 'Wachtwoord',
                        description: 'Makkelijker is niet altijd beter.',
                    },
                    emergencyContacts: {
                        title: 'Noodcontacten',
                        description: 'Jouw contactpersonen in geval van nood.',
                        emptyMessage: 'Voeg één of meer contactpersonen toe.',
                    },
                    profileImage: {
                        title: 'Profielfoto',
                        description: "Hej! Leuk om je te zien!"
                    },
                    other: {
                        title: 'Other',
                        seasons: 'Seasons'
                    },

                    travel: {
                        title: 'Reis',
                        description: 'Geef zo snel mogelijk je reisgegevens aan ons door',
                        dataProcessedMessage: 'Je reisgegevens zijn door ons naar de camping verstuurd. Je kunt deze niet zelf wijzigen. Neem bij wijzigingen in je reisschema contact op met ons kantoor.'
                    },
                    campings: {
                        title: 'Gematchte camping|Gematchte campings',
                        description: 'Dit is de camping waar je aan de slag kunt.|Dit zijn de campings waar je aan de slag kunt.'
                    },
                    documents: {
                        title: 'Documenten',
                        description: 'Al je belangrijke documenten kun je hier vinden.',
                        emptyMessage: 'Er zijn helaas geen documenten om te tonen.',
                        fields: {
                            //
                        },
                        buttons: {
                            download: 'Download bestand'
                        }
                    },
                },
            },
            photoList: {
                title: "Maak fotolijst met één medewerker|Maak fotolijst met {count} medewerkers",
                selectFields: "Velden op profielenlijst",
                selectMatchingboard: "'op matchingbord' aanvinken",
                downloadReady: "De fotolijst staat voor je klaar. De link achter de knop blijft 60 minuten geldig. Daarna moet je een nieuwe link aanvragen.",
                downloadButton: "download fotolijst"
            },
            profileEditBasicinfo: {
                breadcrumb: 'Profiel',
                formHeader: 'Bewerk profiel',
                sections: {
                    basicInfo: {
                        title: 'Basis gegevens',
                        description: 'Dit zijn de meest basis gegevens over deze werknemer die je zal vinden.',
                    },
                    birth: {
                        title: 'Geboorte'
                    }
                }
            },
            profileEditTravel: {
                title: 'Profile',
                breadcrumb: 'Profiel',
                formHeader: 'Bewerk profiel',
                sections: {
                    main: {
                        title: 'Reis',
                        description: 'Geef zo snel mogelijk je reisgegevens aan ons door',
                        dataProcessedMessage: 'Je reisgegevens zijn verstuurd. Neem bij wijzigingen in je reisschema contact op met ons kantoor.'
                    },
                }
            },
            profileEditAddress: {
                breadcrumb: 'Profiel',
                formHeader: 'Bewerk profiel',
                sections: {
                    main: {
                        title: 'Adres',
                        description: 'Zorg er asjeblieft voor dat je adres volledig en correct is.'
                    }
                }
            },
            profileEditEmergencycontacts: {
                breadcrumb: 'Profiel',
                formHeader: 'Bewerk profiel',
                sections: {
                    main: {
                        title: 'Noodcontacten',
                        description: 'Wie kunnen we bellen als de nood aan de man is?',
                    }
                },
                errorMessage: 'Controleer a.u.b. de invoer en probeer het opnieuw.'
            },
            profileEditPassword: {
                title: 'Profiel',
                formHeader: 'Wijzig wachtwoord',
                sections: {
                    main: {
                        title: 'Wachtwoord',
                        description: 'Een sterk wachtwoord is minstens 8 tekens lang en bevat willekeurige letters en cijfers.',
                    }
                },
                errorMessage: 'Controleer a.u.b. de invoer en probeer het opnieuw.'
            },
            profileEdit: {
                title: 'Profiel',
                breadcrumb: 'Profiel',
                formHeader: 'Bewerk profiel',
                errorMessage: 'Controleer a.u.b. de invoer en probeer het opnieuw.'
            },
            employeesEditHistoryExperience: {
                formHeader: 'Contact momenten',
                sections: {
                    main: {
                        title: 'Contact momenten',
                        description: ''
                    }
                }
            },
            search: {
                title: 'Zoeken',
                searchPlaceholder: 'Zoek op naam, camping, plaats, enz.',
                defaultText: 'Start je expeditie met het typen van een zoekterm.',
                resultsPhrase: 'Eén resultaat | {count} resultaten',
                resultsMaximum: '20+ resultaten',
                noResultsCampings: 'Deze zoekactie heeft geen campings opgeleverd.',
                noResultsEmployees: 'Deze zoekactie heeft geen medewerkers opgeleverd.',
                noResultsContactpersons: 'Deze zoekactie heeft geen contactpersonen opgeleverd.',
                noResultsUsers: 'Deze zoekactie heeft geen gebruikers opgeleverd.',
            },
            styleguide: {
                title: 'Stijlgids'
            },
            settingsShow: {
                title: 'Instellingen',
                tabs: {
                    general: 'Algemene instellingen',
                    integrations: 'Integraties / koppelingen',
                    contractSalaries: 'Contract salarissen'
                },
                hourly: 'per uur'
            },
            settingsEdit: {
                title: 'Algemene instelling aanpassen'
            },
            settingsEditContractSalary: {
                title: 'Contract salaris aanpassen'
            },
            componentName: {
                someMessage: 'test 123'
            },
            campingShow: {
                createInfoDocument: 'Maak informatie document',
                sendMail: 'Stuur email',
                sendResumes: 'Verstuur CV\'s',
                sendItinerary: 'Verstuur reisinformatie'
            },
            campingsIndex: {
                title: 'Campings',
                queryCount: 'Geen gevonden campings | Één gevonden camping | {count} gevonden campings',
                deleteConfirmationModalTitle: 'Één camping verwijderen | Verwijder {count} campings',
                deleteConfirmationModalConfirm: 'Één camping verwijderen? | Verwijder {count} campings?',
                scopes: {
                    all: 'Alle',
                    contractSigned: 'Contract ondertekend',
                    new: 'Nieuw',
                    request: 'Request',
                    informationDocument: 'Informatiedocument',
                    continueProfile: 'Profiel doorzetten',
                    profileContinued: 'Profiel doorgezet',
                    completelyMatched: 'Compleet gematched',
                    actionNeeded: 'Actie nodig',
                    archive: 'Archief',
                }
            },
            regionManagerIndex: {
                title: 'Regio manager',
                allSeasons: 'Alle seizoenen'
            },
            settingsEditEmployesKey: {
                title: 'Employes authenticatie',
                description: 'Employes API token',
            },
            payruns: {
                title: 'Betaalruns'
            }
        },
        shared: {
            general: {
                view: 'bekijken',
                save: 'opslaan',
                saving: 'opslaan',
                saveAndContinue: 'opslaan en doorgaan',
                add: 'toevoegen',
                adding: 'toevoegen',
                delete: 'verwijderen',
                deleting: 'verwijderen',
                send: 'versturen',
                sending: 'versturen',
                create: 'aanmaken',
                creating: 'aanmaken',
                cancel: 'annuleren',
                edit: 'bewerk',
                download: 'download',
                actions: 'acties',
                select: 'selecteer',
                deselect: 'deselecteer',
                back: 'ga terug',
                logout: 'Uitloggen',
                login: 'Inloggen',
                oldDocuments: 'Oude Documenten',
                close: 'sluiten',
            },
            overviewColumn: {
                empty: 'Hier staat nog niks.',
            },
            overviewItem: {
                notFilledIn: 'Niet ingevuld',
                readMore: 'Lees meer'
            },
            autocompleteInput: {
                startTyping: 'Begin met typen...'
            },
            overviewSection: {
                add: 'toevoegen',
                edit: 'bewerk',
                connect: 'verbind',
                delete: 'verwijder',
                view: 'bekijken'
            },
            componentName: {
                someMessage: 'test 123'
            }
        },
        models: {
            campingContact: {
                meta: {
                    singular: 'Contactpersoon',
                    plural: 'Contactpersonen',
                    create: 'Voeg contactpersoon toe',
                    edit: 'Bewerk contactpersoon',
                    delete: 'Verwijder contactpersoon'
                },
                firstName: {
                    label: 'Voornaam'
                },
                lastName: {
                    label: 'Achternaam'
                },
                fullName: {
                    label: 'Naam'
                },
                phone: {
                    label: 'Telefoon'
                },
                mobile: {
                    label: 'Mobiel'
                },
                email: {
                    label: 'E-mail'
                },
            },
            contract: {
                meta: {
                    singular: 'Contract',
                    plural: 'Contracten',
                    show: '{type} voor {fullName}',
                    create: '{type} aanmaken voor {fullName}',
                    edit: '{type} aanpassen voor {fullName}',
                    save: 'Contract opslaan',
                    delete: 'Contract verwijderen',
                    downloadPdf: 'Download PDF',
                    createSignRequest: 'SignRequest versturen',
                    createSignInForm: 'Aanmeldformulier maken',
                    sendCampingFoundMail: 'Camping gevonden mail versturen',
                },
                contractType: {
                    label: 'Type'
                },
                contractSalary: {
                    label: 'Salaris'
                },
                employeeDoc: {
                    label: 'Document'
                },
                employeeDocSignRequest: {
                    label: 'SignRequest'
                },
                dateFrom: {
                    label: 'Vanaf'
                },
                dateTill: {
                    label: 'Tot'
                },
                weekNumbers: {
                    label: 'Weeknummers'
                },
                camping: {
                    label: 'Camping(s)'
                },

                period: {
                    label: 'Periode'
                },
                salary: {
                    label: 'Salaris'
                },
                hours: {
                    label: 'Uren'
                },
                createdBy: {
                    label: ''
                },
                createdAt: {
                    label: 'Aangemaakt op'
                },
                status: {
                    label: 'Status',
                    options: {
                        active: 'Actief',
                        expired: 'Verlopen'
                    }
                },
                duration: {
                    label: 'Duur'
                },
                campingInfo: {
                    label: 'Camping informatie'
                },
                active: {
                    label: 'Actief'
                },
                employes: {
                    label: 'Employes'
                }
            },
            camping: {
                meta: {
                    singular: 'Camping',
                    plural: 'Campings',
                    create: 'Camping toevoegen',
                    edit: 'Camping bewerken',
                    delete: 'Camping verwijderen'
                },
                name: {
                    label: 'Naam'
                },
                status: {
                    label: 'Status'
                },
                email: {
                    label: 'Email'
                },
                phone: {
                    label: 'Telefoon'
                },
                seasons: {
                    label: 'Seizoen jaren'
                },
                visiting_address: {
                    label: 'Adres'
                },
                visiting_postalcode: {
                    label: 'Postcode'
                },
                visiting_city: {
                    label: 'Plaats'
                },
                visiting_region: {
                    label: 'Regio'
                },
                department: {
                    label: 'Department'
                },
                country_iso: {
                    label: 'Land code'
                },
                sarl_name: {
                    label: 'Naam'
                },
                sarl_address: {
                    label: 'Adres'
                },
                sarl_postalcode: {
                    label: 'Postcode'
                },
                sarl_city: {
                    label: 'Plaats'
                },
                chain: {
                    label: 'Keten'
                },
                camping_size: {
                    label: 'Formaat'
                },
                siret: {
                    label: 'Siret'
                },
                phone_mobile: {
                    label: 'Mobiele telefoon'
                },
                website: {
                    label: 'Website'
                },
                zoover_url: {
                    label: 'Zoover URL'
                },
                drive_url: {
                    label: 'Drive URL'
                }
            },
            employee: {
                meta: {
                    singular: 'Medewerker',
                    plural: 'Medewerkers',
                    create: 'Medewerker toevoegen',
                    edit: 'Medewerker bewerken',
                    delete: 'Medewerker verwijderen'
                },
                fullName: {
                    label: 'Naam'
                },
                email: {
                    label: 'Email'
                },
                role: {
                    label: 'Gebruikersrol'
                },
                language: {
                    label: 'Taal'
                },
                phone: {
                    label: 'Tel.'
                },
                phoneMobile: {
                    label: 'Telefoon (mobiel)'
                },
                phoneHome: {
                    label: 'Telefoon (thuis)'
                },
                birthplace: {
                    label: 'Geboorteplaats'
                },
                birthday: {
                    label: 'Geboortedatum'
                },
                nationality: {
                    label: 'Nationaliteit'
                },
                street: {
                    label: 'Straatnaam'
                },
                houseNumber: {
                    label: 'Huisnummer'
                },
                addition: {
                    label: 'Toevoeging'
                },
                postalCode: {
                    label: 'Postcode'
                },
                city: {
                    label: 'Woonplaats'
                },
                country: {
                    label: 'Land'
                },
                firstName: {
                    label: 'Voornaam'
                },
                lastName: {
                    label: 'Achternaam'
                },
                middleName: {
                    label: 'Tussenvoegsel'
                },
                initials: {
                    label: 'Initialen'
                },
                gender: {
                    label: 'Geslacht',
                    options: {
                        neutral: 'Neutraal',
                        male: 'Man',
                        female: 'Vrouw'
                    }
                },
                nationaility: {
                    label: 'Nationaliteit'
                },
                placeOfBirth: {
                    label: 'Geboorteplaats'
                },
                transactionId: {
                    label: 'Transactie ID'
                },
                availableFrom: {
                    label: 'Beschikbaar vanaf'
                },
                availableUntil: {
                    label: 'Beschikbaar tot'
                },
                availableLonger: {
                    label: 'Langer beschikbaar',
                    description: 'Medewerker is beschikbaar voor een langere periode'
                },
                availableShorter: {
                    label: 'Korter beschikbaar',
                    description: 'Medewerker is beschikbaar voor een kortere periode'
                },
                declarationOfIntentType: {
                    label: ''
                },
                declarationOfIntentComment: {
                    label: ''
                },
                clothingSize: {
                    label: 'Kledingmaat'
                },
                seasons: {
                    label: 'Seizoenen'
                },
                clothingSend: {
                    label: 'Kleding verstuurd'
                },
                trainingRefresher: {
                    label: 'Opfriscursus frans'
                },
                languageProficiencySummary: {
                    label: 'Samenvatting Frans niveau'
                },
                languageProficiencySummaryFrench: {
                    label: 'Samenvatting Frans niveau (Frans)'
                },
                educationFrench: {
                    label: 'Franse samenvatting van de opleidingen'
                },
                passportReceived: {
                    label: 'Paspoort ontvangen'
                },
                passportExpiresAt: {
                    label: 'Paspoort verloopt op'
                },
                registeredSvb: {
                    label: 'Geregistreerd bij SVB'
                },
                registeredPayrollAdministration: {
                    label: 'Aangemeld op Payroll'
                },
                matchingBoard: {
                    label: 'Matchingsbord'
                },
                interestedT4e: {
                    label: 'Geinteresseerd in T4E'
                },
                payrollT4e: {
                    label: 'Payroll voor T4E'
                },
                payrollJ4l: {
                    label: 'Payroll voor J4L'

                },
                authorizationReturned: {
                    label: 'Goedkeuring ontvangen'
                },
                substitute: {
                    label: 'Invaller'
                },
                mandateDate: {
                    label: 'Mandaatdatum'
                },
                converted: {
                    label: 'Omgezet'
                },
                transitioned: {
                    label: 'Getransitioneerd'
                },
                recruiter: {
                    label: 'Recruiter'
                },
                trainingWeekendInvited: {
                    label: 'Uitgenodigd voor trainingsweekend'
                },
                trainingWeekendConfirmed: {
                    label: 'Trainingsweekend bevestigd'
                },
                trainingWeekendPaid: {
                    label: 'Trainingsweekend betaald'
                },
                trainingWeekendGroup: {
                    label: 'Trainingsweekend groep'
                },
                reunionDay: {
                    label: 'Uitgenodigd voor reunie'
                },
                topMeetupInvited: {
                    label: 'Uitnodiging TOP Meetup verstuurd',
                },
                topMeetupConfirmed: {
                    label: 'TOP Meetup bevestigd',
                },
                preferredFunction1: {
                    label: 'Voorkeursfunctie 1'
                },
                preferredFunction2: {
                    label: 'Voorkeursfunctie 2'
                },
                preferredCountry: {
                    label: 'Voorkeursland'
                },
                preferredCamping: {
                    label: 'Voorkeurscamping'
                },
                preferredTeam: {
                    label: 'Voorkeursteam'
                },
                otherPeferences: {
                    label: 'Overige voorkeuren'
                },
                level: {
                    label: 'Schoolniveau'
                },
                frenchTill: {
                    label: 'Frans tot'
                },
                speakingSkills: {
                    label: 'Spreekvaardigheid'
                },
                estimationFrench: {
                    label: 'Inschatting frans'
                },
                trainingRefresher2: {
                    label: 'Opfriscursus 2'
                },
                ovbFrench: {
                    label: 'Onder voorbehoud van Frans'
                },
                trainingRefresherSend: {
                    label: ''
                },
                estimationGerman: {
                    label: 'Inschatting Duits'
                },
                estimationItalian: {
                    label: 'Inschatting Italiaans'
                },
                estimationSpanish: {
                    label: 'Inschatting Spaans'
                },
                estimationEnglish: {
                    label: 'Inschatting Engels'
                },
                workExperienceFrench: {
                    label: 'Werkervaring in het Frans'
                },
                recruitmentChannel: {
                    label: 'Recruitment kanaal'
                },
                firstSeason: {
                    label: 'Eerste seizoen'
                },
                yearsExperience: {
                    label: 'Jaren ervaring'
                },
                formerEmployee: {
                    label: 'Oud medewerker',
                },
                createdBy: {
                    label: 'Aangemaakt door'
                },
                experienceSportNl: {
                    label: 'In het kader van sport'
                },
                experienceSportFr: {
                    label: 'In het kader van sport (Frans)'
                },
                experienceKidsNl: {
                    label: 'In het kader van kinderen '
                },
                experienceKidsFr: {
                    label: 'In het kader van kinderen (Frans)'
                },
                experienceShowNl: {
                    label: 'In het kader van shows '
                },
                experienceShowFr: {
                    label: 'In het kader van shows (Frans)'
                },
                bsn: {
                    label: 'BSN'
                },
                iban: {
                    label: 'IBAN'
                },
                bic: {
                    label: 'BIC'
                },
                payroll_tax: {
                    label: 'Loonheffingskorting'
                },
                status: {
                    label: 'Status'
                },
                drivingLicense: {
                    label: 'Rijbewijs'
                },
                vaccinated: {
                    label: 'Kleding ontvangen'
                },
                dontContactAnymore: {
                    label: 'Niet meer contacten'
                }
            },
            application: {
                remarks: {
                    label: 'Opmerkingen'
                },
                date: {
                    label: 'Datum'
                },
                time: {
                    label: 'Tijd'
                },
                week6done: {
                    label: 'Week 6 afgerond',
                    description: 'Zijn alle taken afgerond na 6 weken?'
                },
                week12done: {
                    label: 'Week 12 afgerond',
                    description: 'Zijn alle taken afgerond na 1 weken?'
                },
                skype: {
                    label: 'Skype',
                    description: 'Is de sollicitatie via Skype?'
                },
            },
            document: {
                doc_url: {
                    label: 'URL'
                },
                filename: {
                    label: 'Bestandsnaam'
                },
                type: {
                    label: 'Bestandstype'
                },
                public: {
                    label: 'Openbaar'
                },
                visibility: {
                    label: 'Zichtbaarheid'
                },
                createdBy: {
                    label: 'Geupload door'
                },
                createdAt: {
                    label: 'Geupload op'
                },
                visibilityEmployee: {
                    label: 'Zichtbaar voor medewerker'
                },
                visibilityT4a: {
                    label: 'Zichtbaar voor TOPAnimation'
                },
                signRequestStatus: {
                    label: 'SignRequest status'
                }
            },

            evaluation: {
                appearance: {
                    label: 'Uiterlijk voorkomen',
                    description: 'Vertel na de sollicitatie je bevindingen over de kandidaat.'
                },
                independence: {
                    label: 'Zelfstandigheid',
                    description: 'Vertel na de sollicitatie je bevindingen over de kandidaat.'
                },
                flexibility: {
                    label: 'Flexibiliteit',
                    description: 'Vertel na de sollicitatie je bevindingen over de kandidaat.'
                },
                campingType: {
                    label: 'Camping type',
                    description: 'Vertel na de sollicitatie je bevindingen over de kandidaat.'
                },
                notesOther: {
                    label: 'Notities',
                    description: 'Wil je nog iets bijzonders toevoegen over deze kandidaat?'
                },
            },
            education: {
                education: {
                    label: 'Opleiding'
                },
                educationDate: {
                    label: 'Afgerond'
                },
            },
            mailtemplate: {
                meta: {
                    singular: 'Mailtemplate',
                    plural: 'Mailtemplates',
                    create: 'Template aanmaken',
                    edit: 'Bewerk template',
                    delete: 'Verwijder template'
                },
                name: {
                    label: 'Template naam'
                },
                locale: {
                    label: 'Taal',
                    options: {
                        nl: 'Nederlands',
                        fr: 'Frans',
                    }

                },
                model: {
                    label: 'Template type',
                    options: {
                        employee: 'Medewerker',
                        camping: 'Camping',
                    }

                },
                slug: {
                    label: 'Slug'
                },
                defaultFromEmail: {
                    label: 'Standaard email afzender',
                },
                defaultFromName: {
                    label: 'Standaard naam afzender',

                },
                defaultCc: {
                    label: 'Standaard CC'
                },
                defaultBcc: {
                    label: 'Standaard BCC'
                },
                defaultSubject: {
                    label: 'Standaard onderwerp'
                },
                defaultContent: {
                    label: 'Standaard inhoud'
                },
            },

            status: {
                date: {
                    label: 'Datum'
                },
                status: {
                    label: 'Status'
                },
                addedBy: {
                    label: 'Toegevoegd door'
                }
            },
            employeeNote: {
                date: {
                    label: 'Datum'
                },
                note: {
                    label: 'Notitie'
                },
                addedBy: {
                    label: 'Toegevoegd door'
                }
            },
            workExperience: {
                company: {
                    label: 'Bedrijf'
                },
                function: {
                    label: 'Functie'
                },
                description: {
                    label: 'Omschrijving'
                },
            },
            user: {
                meta: {
                    singular: 'Gebruiker',
                    plural: 'Gebruikers',
                    create: 'Gebruiker aanmaken',
                    edit: 'Bewerk gebruiker',
                    delete: 'Verwijder gebruiker'
                },
                name: {
                    label: 'Naam'
                },
                email: {
                    label: 'Email'
                },
                userRole: {
                    label: 'Gebruikersrol'
                },
                password: {
                    label: 'Wachtwoord'
                },
                passwordOriginal: {
                    label: 'Huidige wachtwoord'
                },
                passwordNew: {
                    label: 'Nieuwe wachtwoord',
                    error: 'Eén of meerdere velden zijn niet correct ingevuld. Controleer je invoer en probeer het opnieuw.',
                    errors: {
                        minimalChars: 'A good password is at least 8 characters. Add some more.',
                        sameAsOldPassword: 'Your new password should differ from your old one.',
                        confirmationNotEqual: 'Your confirmation is not the same as your new password.'
                    }
                },
                passwordConfirmation: {
                    label: 'Herhaal je nieuwe wachtwoord'
                },
                language: {
                    label: 'Taal'
                },

            },
            emergencyContacts: {
                name: {
                    label: 'Naam'
                },
                phoneMobile: {
                    label: 'Mobiel'
                },
                phoneHome: {
                    label: 'Telefoon'
                }
            },
            personnelProcess: {
                passportReceived: {
                    label: 'Paspoort ontvangen'
                },
                passportExpiresAt: {
                    label: 'Paspoort vervalt op'
                },
                isASubstitute: {
                    label: 'Is een invaller'
                },
                substituteDate: {
                    label: 'Inval datum'
                },
                registeredSvb: {
                    label: 'SVB geregistreerd'
                },
                registeredPayroll: {
                    label: 'Aangemeld op Payroll'
                },
                matchingBoard: {
                    label: 'Matchingbord'
                },
                interestedT4e: {
                    label: 'Geïnteresseerd in T4E'
                },
                payrollT4e: {
                    label: 'Loonlijst T4E'
                },
                payrollJ4l: {
                    label: 'Loonlijst J4L'
                },
                authorizationReturned: {
                    label: 'Autorisatie teruggegeven'
                },
                converted: {
                    label: 'Omgezet (converted)'
                },
                transitioned: {
                    label: 'Overgegaan (transitioned)'
                },
                mandateDate: {
                    label: 'Mandaat datum'
                }
            },
            employeesEditAvailability: {
                availableFrom: {
                    label: 'Beschiktbaar vanaf'
                },
                availableUntil: {
                    label: 'Beschiktbaar tot'
                },
                availableLonger: {
                    label: 'Langer beschiktbaar'
                },
                availableShorter: {
                    label: 'Korter beschiktbaar'
                },
                availability: {
                    label: 'Beschikbaarheid'
                }
            },
            employeesEditTrainingreunion: {
                trainingWeekendInvited: {
                    label: 'Uitgenodigd voor trainingsweekend'
                },
                trainingWeekendConfirmed: {
                    label: 'Trainingsweekend bevestigd'
                },
                trainingWeekendPaid: {
                    label: 'Trainingsweekend betaald'
                },
                trainingWeekendGroup: {
                    label: 'Trainingsweekend groep'
                },
                reunionDay: {
                    label: 'Uitgenodigd voor reunie'
                }
            },
            employeesEditTopMeetup: {
                topMeetupInvited: {
                    label: 'Uitnodiging TOP Meetup verstuurd'
                },
                topMeetupConfirmed: {
                    label: ' TOP Meetup bevestigd'
                },
            },
            employeesEditExperience: {
                experienceSportNl: {
                    label: 'Ervaring sport NL'
                },
                experienceSportFr: {
                    label: 'Ervaring sport FR'
                },
                experienceKidsNl: {
                    label: 'Ervaring kinderen NL'
                },
                experienceKidsFr: {
                    label: 'Ervaring kinderen FR'
                },
                experienceShowNl: {
                    label: 'Ervaring show NL'
                },
                experienceShowFr: {
                    label: 'Ervaring show FR'
                }
            },
            employeesEditPreferences: {
                preferredFunction1: {
                    label: 'Functie 1'
                },
                preferredFunction2: {
                    label: 'Functie 2'
                },
                preferredCountry: {
                    label: 'Land'
                },
                preferredCamping: {
                    label: 'Camping',
                    options: {
                        small: 'Klein',
                        smallMedium: 'Klein/medium',
                        medium: 'Medium',
                        mediumLarge: 'Medium/groot',
                        large: 'Groot'
                    }
                },
                preferredTeam: {
                    label: 'Team'
                },
                otherPreferences: {
                    label: 'Andere voorkeuren'
                },
            },
            employeeTravel: {
                date: {
                    label: 'Aankomstdatum'
                },
                time: {
                    label: 'Tijd'
                },
                arrival: {
                    label: 'Plaats'
                },
                arrivalType: {
                    label: 'Aankomst op'
                },
                data: {
                    label: 'Reisgegevens doorgestuurd'
                },
                dataProcessed: {
                    label: 'Reisgegevens verwerkt'
                },
                expenses: {
                    label: 'Reiskosten'
                },
                tripNumber: {
                    label: 'Trip number'
                },
            },
            contractSalary: {
                description: {
                    label: 'Salaris omschrijving'
                },
                salary: {
                    label: 'Salaris bedrag'
                },
                hourWage: {
                    label: 'Uurloon bedrag'
                }
            },
            payruns: {
                meta: {
                    plural: 'betaalruns',
                    singular: 'betaalrun',
                },
                period: 'periode',
                processed: 'verwerkt',
                dateRange: 'Datumbereik',
                retrieve: 'Binnenhalen'
            }
        },
        buttons: {
            create: 'aanmaken',
            creating: 'bezig met aanmaken...',
            save: 'opslaan',
            saving: 'bezig met opslaan...',
            cancel: 'annuleren',
        }
    },
    en: {
        pages: {
            tokenInvalid: {
                title: "Link is no longer valid.",
                description: "The link you used is no longer valid. The link will expire 48 hours after sending the email. ",
                solution: "Request a new link with the forgot password feature.",
                button: 'Forgot your password'
            },

            login: {
                title: 'Hey hallo!',
                caution: 'Let op!',
                instructions: 'Het TeamAnimation account is vernieuwd. Je krijgt nieuwe inloggegevens zodra je een nieuw document van ons krijgt. Wil je eerder toegang? Mail even ',
                rememberMe: 'Keep me logged in',
                passwordForgotten: 'Forgot your password?',
                login: 'Login',
            },
            campingsMail: {
                pageHeader: 'Send an email',
                modal: {
                    title: 'Email variables',
                    show: 'Show email variables'
                },
                sections: {
                    template: {
                        changeTemplateButton: 'change template',
                        useThisTemplateButton: 'Use template',
                        withoutTemplateButton: 'Without template'
                    },
                    meta: {
                        title: 'Mail data',
                        description: 'The most important part of writing an email.  ',
                        to: 'To',
                        fromName: 'From (name)',
                        fromEmail: 'From (email)',
                        cc: 'CC',
                        bcc: 'BCC',
                        subject: 'Subject'
                    },
                    content: {
                        title: 'Email content',
                        description: 'Use your template tags to make it personal!'
                    }
                }
            },
            campingsItinerary: {
                pageHeader: 'Send an email',
                sections: {
                    meta: {
                        title: 'Mail data',
                        description: 'The most important part of writing an email.  ',
                        to: 'To',
                        cc: 'CC',
                        subject: 'Subject'
                    },
                    content: {
                        title: 'Email content',
                        description: 'Use your template tags to make it personal!'
                    }
                }
            },
            employeesMail: {
                pageHeader: 'Send an email',
                modal: {
                    title: 'Email variables',
                    show: 'Show email variables'
                },
                sections: {
                    template: {
                        changeTemplateButton: 'change template',
                        useThisTemplateButton: 'Use template',
                        withoutTemplateButton: 'Without template'
                    },
                    meta: {
                        title: 'Mail data',
                        description: 'The most important part of writing an email.  ',
                        to: 'To',
                        fromName: 'From (name)',
                        fromEmail: 'From (email)',
                        cc: 'CC',
                        bcc: 'BCC',
                        subject: 'Subject'
                    },
                    content: {
                        title: 'Email content',
                        description: 'Use your template tags to make it personal!'
                    }
                }
            },
            employeesIndex: {
                title: 'Employees',
                queryCount: 'No employees found | Found one employee | Found {count} employees',
                photolistConfirmationModal: {
                    title: 'Create photo list',
                    description: 'You will create a photo list with one employee. You can select the desired fields in the following step.|You will create a photo list with {count} employees. You can select the desired fields in the following step.',
                    confirmText: 'create photo list'
                },
                createUserAccountsConfirmationModal: {
                    title: 'Create user accounts for this employee|Create {count} user accounts',
                    description: "We will create user accounts for this employees if they haven't one already",
                    confirmText: 'create user account|create {count} user accounts'
                },
                scopes: {
                    active: 'Status active',
                    archive: 'Status archive',
                    declarationOfIntentSigned: 'Signed declaration of intend',
                    declarationOfIntentSend: 'Send declaration of intend',
                    contractSend: 'Send contract',
                    missingDocuments: 'Missing documents',
                    readyForSeason: 'Ready for season',
                    readyForMatchingBoard: 'Ready for matchingbord',
                    jobApplicationInFourteenDays: 'In 14 days',
                    sixWeekCall: '6 weeks call',
                    twelveWeekCall: '12 weeks call',
                    substitute: 'Substitutes',
                    actionNeeded: 'Action needed',
                }
            },
            employeesShow: {
                title: 'Employees',
                allEmployees: 'All employees',
                tabs: {
                    general: 'General',
                    application: 'Application',
                    contract: 'Contract',
                    animationWork: 'Animation work',
                    travel: 'Travel',
                    document: 'Documents',
                    history: 'History',
                    notes: 'Notes',
                    education: 'Education & Experience'
                },
                actions: {
                    title: 'Actions',
                    contractNL: 'Create contract - NL',
                    contractFR: 'Create contract - FR',
                    profileFR: 'Profile PDF - FR',
                    signDeclarationOfIntent: 'Let sign declaration of intent',
                    signPayrollTaxForm: 'Let sign payroll tax form',
                    signLearningAgreement: 'Let sign learning agreement',
                    createUserAccount: 'Create user account',
                    seeUserAccount: 'See user account',
                    sendAnEmail: 'Send an email',
                    goToAirtable: 'Go to Airtable',
                    sendToWhatsapp: 'Send WhatsApp message',
                    addToEmployes: 'Add to Employes',
                },
                sections: {
                    basicInfo: {
                        title: 'General info',
                        description: ''
                    },
                    address: {
                        title: 'Address',
                        description: ''
                    },
                    emergencyContact: {
                        title: 'Emergency contactinformation',
                        description: '',
                        emptyMessage: 'Add one or more contactpersons.',
                    },
                    profileImage: {
                        title: 'Profile photo',
                        description: "Upload a profile photo"
                    },
                    application: {
                        title: 'Application date/time',
                        description: ""
                    },
                    historyExperience: {
                        title: 'Contact moments',
                        description: ''
                    },
                    history: {
                        title: 'History',
                        description: 'What happened to this employee in this app.'
                    },
                    travel: {
                        title: 'Travel details',
                        description: 'Details of the employees travel'
                    },
                    other: {
                        title: 'Other info',
                        seasons: 'Seasons'
                    },
                    finance: {
                        title: 'Financial Information',
                    },
                    personalProcess: {
                        title: 'Presonal Process',
                    },
                    languageProficiency: {
                        title: 'Language Proficiency',
                    },
                    education: {
                        title: 'Education',
                        description: 'All the educations that the person has done.',
                    },
                    experience: {
                        title: 'Experience',
                    },
                    workExperience: {
                        title: 'Work experience',
                        description: 'All the work experience that the person has.',
                        add: 'Add some work experiences',
                    },
                    availability: {
                        title: 'Availibility',
                    },
                    trainingAndReunion: {
                        title: 'Training and reunion',
                    },
                    topMeetup: {
                        title: 'TOP Meetup',
                    },
                    preferences: {
                        title: 'Preferences',
                    },
                    documents: {
                        title: 'Documents',
                        description: 'All documents relevant to this employee.',
                    },
                    notes: {
                        title: 'Notes',
                        description: 'The notes which are relevant to this employee.',
                    },
                    contracts: {
                        title: 'Contracts',
                        downloadInfoDoc: 'Download information document'
                    }
                }
            },
            mailtemplatesIndex: {
                pageHeader: '',
                deleteConfirmationModal: {
                    title: 'Delete template \'{templateName}\'',
                    description: 'You will delete the entire template from the system. This action can not be undone',
                    confirmText: 'delete template'
                }
            },
            mailtemplatesCreate: {
                pageHeader: '',
                sections: {
                    meta: {
                        title: 'Template settings',
                        description: 'This are the default settings of the template. They can be changed when you are sending an email.'
                    }
                }
            },
            mailtemplatesEdit: {
                pageHeader: 'Edit mailtemplate',
                sections: {
                    meta: {
                        title: 'Template settings',
                        description: 'This are the default settings of the template. They can be changed when you are sending an email.'
                    }
                }
            },


            contractShow: {
                pageHeader: 'Contract',
                sections: {
                    employee: {
                        title: 'Employee',
                        description: 'This is the employee involved in the contract.'
                    },
                    contract: {
                        title: 'Contract',
                        description: 'Some more in-depth information about this particular contract.',
                        createContractWithSignRequest: 'Send SignRequest',
                        createContractWithoutSignRequest: 'Create contract document',
                        pushContractToEmployes: 'Add to employes '
                    }
                }
            },
            contractEdit: {
                pageHeader: 'Contract',
                sections: {
                    main: {
                        title: 'Contract',
                        description: 'Here you can alter some details of the contract'
                    },
                }
            },
            contractCreate: {
                sectionTitle: '{type}',
                sectionDescription: 'Please fill in the fields to generate a {type} for {fullName}'
            },
            contractsIndex: {
                title: 'Contracts',
                queryCount: 'No contracts found | Found one contract | Found {count} contracts',
                scopes: {
                    all: 'All',
                    notSigned: 'Not signed',
                    signed: 'Signed',
                    signedEmployesFalse: 'Signed + Employes',
                    expiresInFortyFiveDays: 'Expires in 45 days',
                    expired: 'Expired',
                }
            },
            employeesCreate: {
                formHeader: 'New employee data',
                sections: {
                    main: {
                        title: 'General',
                        description: 'We need this data to add an employee. Other data can be added in the next steps.'
                    }
                }
            },
            employeesEditBasicinfo: {
                formHeader: 'Edit employee',
                sections: {
                    basicInfo: {
                        title: 'Basic info',
                        description: 'The basic information about this employee.'
                    },
                    birth: {
                        title: 'Birth'
                    }
                }
            },
            employeesEditAddress: {
                formHeader: 'Edit employee',
                sections: {
                    main: {
                        title: 'Address',
                        description: 'This is the address where our employee mainly lives'
                    }
                }
            },
            employeesEditOther: {
                formHeader: 'Edit employee',
                sections: {
                    main: {
                        title: 'Other'
                    }
                }
            },
            employeesEditEmergencycontacts: {
                formHeader: 'Edit employee',
                sections: {
                    main: {
                        title: 'Emergency contacts',
                        description: 'Who can we call if it is very very urgent?'
                    }
                },
                errorMessage: 'Please check your input and try again.'
            },
            employeesEditApplication: {
                formHeader: 'Edit employee',
                sections: {
                    main: {
                        title: 'General',
                        description: 'Basic information about the application.'
                    }
                }
            },
            employeesEditAppearance: {
                formHeader: 'Edit employee',
                sections: {
                    main: {
                        title: 'Appearance',
                        description: 'Tell us what you think of the candidate after the interview.'
                    }
                }
            },
            employeesEditIndependence: {
                formHeader: 'Edit employee',
                sections: {
                    main: {
                        title: 'Independence',
                        description: 'Tell us what you think of the candidate after the interview.'
                    }
                }
            },
            employeesEditFlexibility: {
                formHeader: 'Edit employee',
                sections: {
                    main: {
                        title: 'Flexibility',
                        description: 'Tell us what you think of the candidate after the interview.'
                    }
                }
            },
            employeesEditCampingtype: {
                formHeader: 'Edit employee',
                sections: {
                    main: {
                        title: 'Camping type',
                        description: 'Tell us what you think of the candidate after the interview.'
                    }
                }
            },
            employeesEditNotes: {
                formHeader: 'Edit employee',
                sections: {
                    main: {
                        title: 'Notes',
                        description: 'Do you need to tell anything else about the employee?'
                    }
                }
            },
            employeesEditSecondaryeducation: {
                formHeader: 'Edit employee',
                sections: {
                    frenchLanguage: {
                        title: 'French language',
                        description: 'What is the general level of the French language?'
                    },
                    otherLanguages: {
                        title: 'Other languages'
                    }
                }
            },
            employeesEditEducations: {
                formHeader: 'Edit employee',
                sections: {
                    main: {
                        title: 'Education',
                        description: 'All the educations that the person has done.'
                    }
                },
                errorMessage: 'Please check your input and try again.'
            },
            employeesEditWorkexperience: {
                formHeader: 'Edit employee',
                sections: {
                    main: {
                        title: 'Work experience',
                        description: 'All the work experience that the person has.'
                    }
                },
                errorMessage: 'Please check your input and try again.'
            },
            employeesEditPersonnelprocess: {
                formHeader: 'Personel process',
                sections: {
                    passport: {
                        title: 'Passport'
                    },
                    substitute: {
                        title: 'Substitute'
                    },
                    educationAgreement: {
                        title: 'Education agreement'
                    },
                    variousOptions: {
                        title: 'Various options'
                    }
                }
            },
            employeesEditFinance: {
                formHeader: 'Financial',
                sections: {
                    finance: {
                        title: 'Financial information'
                    }
                }
            },
            employeesEditAvailability: {
                formHeader: 'Availability',
                sections: {
                    main: {
                        title: 'Availability'
                    }
                }
            },
            employeesEditTrainingreunion: {
                formHeader: 'Training and reunion',
                sections: {
                    main: {
                        title: 'Training and reunion'
                    }
                }
            },
            employeesEditTopMeetup: {
                formHeader: 'TOP Meetup',
                sections: {
                    main: {
                        title: 'TOP Meetup'
                    }
                }
            },
            employeesEditExperience: {
                formHeader: 'Experience',
                sections: {
                    main: {
                        title: 'Experience'
                    }
                }
            },
            employeesEditTravel: {
                formHeader: 'Travel',
                sections: {
                    main: {
                        title: 'Travel details',
                        description: 'Details of the employees travel'
                    }
                }
            },
            employeesEditPreferences: {
                formHeader: 'Preferences',
                sections: {
                    main: {
                        title: 'Preferences'
                    }
                }
            },

            profileShow: {
                title: 'Profile',
                tabs: {
                    general: 'General info',
                    documents: 'Documents',
                    travel: 'Travel'
                },
                sections: {
                    basicInfo: {
                        title: 'Basic Info',
                        description: 'Here are your personal details. If you need to change other data, please contact our office.',
                        fields: {
                            name: 'Name',
                            email: 'Emailaddress',
                            role: 'Role',
                            language: 'Application language',
                            phoneMobile: 'Phone (mobile)',
                            phoneHome: 'Phone (home)',
                            birthplace: 'Birth place',
                            birthday: 'Birthday',
                            nationality: 'Nationality',

                        }
                    },
                    emergencyContacts: {
                        title: 'Emergency contacts',
                        description: 'Your contact persons in case of emergency.',
                        emptyMessage: 'Please add one or more emergency contacts',
                        fields: {
                            name: 'Name',
                            phoneMobile: 'Phone (mobile)',
                            phoneHome: 'Phone (home)',
                        }
                    },
                    password: {
                        title: 'Password',
                        description: 'Easier is not always better',
                        emptyMessage: 'Make sure your password is safe and strong!',
                        fields: {
                            password: 'Password'
                        }

                    },
                    address: {
                        title: 'Address',
                        description: 'Please make sure that your address is complete and correct.'
                    },
                    profileImage: {
                        title: 'Profile image',
                        description: "It's so nice to see someones face"
                    },
                    travel: {
                        title: 'Travel',
                        description: 'Please fill in your travel details as soon as possible',
                        dataProcessedMessage: 'Your travel data is processed already. Please contact us if anything changes.'
                    },
                    campings: {
                        title: 'Your camping|Your Camping',
                        description: 'This are the campings you can jump into.'
                    },
                    documents: {
                        title: 'Documents',
                        description: 'All your relevant documents will show up here.',
                        emptyMessage: 'There are no documents to show.',
                        fields: {
                            document: 'Document',
                            date: 'Date',
                            category: 'Category',
                            uploadedBy: 'Uploaded by',
                            uploadedOn: 'Uploaded on',
                            documentType: 'Document type'
                        },
                        buttons: {
                            download: 'Download file'
                        }
                    },

                    sectionName: {
                        title: 'title in the sidebar',
                        description: 'description in the sidebar',
                        emptyMessage: 'Please add one or more ',
                        fields: {
                            fieldName: 'translation',
                            anotherFieldName: 'translation',
                        }
                    }
                },
            },
            photoList: {
                title: "Create a photolist with one employee|Create a photolist with {count} employees",
                selectFields: "Fields on photolist",
                selectMatchingboard: "check 'on matchingboard'",
                downloadReady: "Your photolist is ready! The link will expire in 60 minutes. After that you need to generate a new photolist. ",
                downloadButton: "download photolist"
            },
            profileEditBasicinfo: {
                title: 'Profile',
                breadcrumb: 'Profile',
                formHeader: 'Edit profile',
                sections: {
                    basicInfo: {
                        title: 'Basic Info',
                        description: 'Here are your personal details. If you need to change other data, please contact our office.',
                    },
                    birth: {
                        title: 'Birth'
                    }
                }
            },
            profileEditTravel: {
                title: 'Profile',
                breadcrumb: 'Profile',
                formHeader: 'Edit profile',
                sections: {
                    main: {
                        title: 'Travel',
                        description: 'Please fill in your travel details as soon as possible',
                    },
                }
            },
            profileEditAddress: {
                title: 'Profile',
                breadcrumb: 'Profile',
                formHeader: 'Edit profile',
                sections: {
                    main: {
                        title: 'Address',
                        description: 'Please make sure that your address is complete and correct.'
                    }
                }
            },
            profileEditEmergencycontacts: {
                title: 'Profile',
                breadcrumb: 'Profile',
                formHeader: 'Edit profile',
                sections: {
                    main: {
                        title: 'Emergency contacts',
                        description: 'Who can we call if it is very very urgent?',
                    }
                },
                errorMessage: 'Please check your input and try again.'
            },
            profileEditPassword: {
                title: 'Profile',
                breadcrumb: 'Profile',
                formHeader: 'Edit password',
                sections: {
                    main: {
                        title: 'Password',
                        description: 'A strong password is at least 8 characters long and contains just random chars and numbers.',
                    }
                },
                errorMessage: 'Please check your input and try again.'
            },
            profileEdit: {
                title: 'Profile',
                breadcrumb: 'Profile',
                formHeader: 'Edit profile',
                errorMessage: 'Please check your input and try again.'
            },
            campingShow: {
                createInfoDocument: 'Create information document',
                sendMail: 'Send email',
                sendResumes: 'Email resumes',
                sendItinerary: 'Email itinerary'
            },
            campingsIndex: {
                title: 'Campsites',
                queryCount: 'No campsites found | Found one campsite | Found {count} campsites',
                deleteConfirmationModalTitle: 'delete one camping | delete {count} campings',
                deleteConfirmationModalConfirm: 'delete one camping | delete {count} campings',
                scopes: {
                    all: 'All',
                    contractSigned: 'Contract signed',
                    request: 'Request',
                    new: 'New',
                    informationDocument: 'Information document',
                    continueProfile: 'Continue profile',
                    profileContinued: 'Profiel continued',
                    completelyMatched: 'Completely matched',
                    actionNeeded: 'Action Needed',
                    archive: 'Archive',
                }
            },
            search: {
                title: 'Search',
                searchPlaceholder: 'Search for names, campsites, cities, etc',
                defaultText: 'Start your expedition by typing some keywords.',
                resultsPhrase: 'One result | {count} results',
                resultsMaximum: '20+ results',
                noResultsCampings: 'This search returned no campsites.',
                noResultsEmployees: 'This search returned no employees.',
                noResultsContactpersons: 'This search returned no contact persons.',
                noResultsUsers: 'This search returned no users.',
            },
            styleguide: {
                title: 'Styleguide'
            },
            settingsShow: {
                title: 'Settings',
                tabs: {
                    general: 'General settings',
                    integrations: 'Integration',
                    contractSalaries: 'Contract salaries'
                },
                hourly: 'hourly'
            },
            settingsEdit: {
                title: 'Change general settings'
            },
            settingsEditContractSalary: {
                title: 'Change contract salary'
            },
            regionManagerIndex: {
                title: 'Region manager'
            },
            settingsEditEmployesKey: {
                title: 'Employes authentication',
                description: 'Employes API token',
            },
            payruns: {
                title: 'Payruns'
            }
        },
        shared: {
            general: {
                view: 'view',
                save: 'save',
                saving: 'saving',
                saveAndContinue: 'save and continue',
                add: 'add',
                adding: 'adding',
                delete: 'delete',
                deleting: 'deleting',
                send: 'send',
                sending: 'sending',
                create: 'create',
                creating: 'creating',
                cancel: 'cancel',
                edit: 'edit',
                download: 'download',
                actions: 'actions',
                select: 'select',
                deselect: 'deselect',
                back: 'take me back',
                logout: 'log off',
                login: 'log in',
                oldDocuments: 'old documents',
                close: 'close',
            },
            overviewItem: {
                notFilledIn: 'Not filled in',
                readMore: 'Read more'
            },
            autocompleteInput: {
                startTyping: 'Start typing...'
            },
            overviewSection: {
                add: 'add',
                edit: 'edit',
                connect: 'connect',
                delete: 'delete',
                view: 'view'
            },
        },
        models: {
            campingContact: {
                meta: {
                    singular: 'Contact person',
                    plural: 'Contact persons',
                    create: 'Create contact person',
                    edit: 'Edit contact person',
                    delete: 'Delete contact person'
                },
                firstName: {
                    label: 'First name'
                },
                lastName: {
                    label: 'Last name'
                },
                fullName: {
                    label: 'Full name'
                },
                phone: {
                    label: 'Phone'
                },
                mobile: {
                    label: 'Mobile'
                },
                email: {
                    label: 'Email'
                },
            },
            contract: {
                meta: {
                    singular: 'Contract',
                    plural: 'Contracts',
                    show: '{type} for {fullName}',
                    create: 'Create {type} for {fullName}',
                    edit: 'Edit {type} for {fullName}',
                    save: 'Save contract',
                    delete: 'Delete contract',
                    downloadPdf: 'Download PDF',
                    createSignRequest: 'Create SignRequest',
                    createSignInForm: 'Create sign in form',
                    sendCampingFoundMail: 'Send camping found mail',
                },
                contractType: {
                    label: 'Contract type'
                },
                contractSalary: {
                    label: 'Salary'
                },
                employeeDoc: {
                    label: 'Document'
                },
                employeeDocSignRequest: {
                    label: 'SignRequest'
                },
                dateFrom: {
                    label: 'From'
                },
                dateTill: {
                    label: 'Till'
                },
                weekNumbers: {
                    label: 'Week numbers'
                },
                camping: {
                    label: 'Camping / Campings'
                },
                period: {
                    label: 'Period'
                },
                salary: {
                    label: 'Salary'
                },
                hours: {
                    label: 'Hours'
                },
                createdBy: {
                    label: 'Created by'
                },
                createdAt: {
                    label: 'Created at'
                },
                status: {
                    label: 'Status',
                    options: {
                        active: 'Active',
                        expired: 'Expired'
                    }
                },
                duration: {
                    label: 'Duration'
                },
                campingInfo: {
                    label: 'camping info'
                },
                active: {
                    label: 'Currently Active'
                },
                employes: {
                    label: 'Employes'
                }
            },
            camping: {
                meta: {
                    singular: 'Camping',
                    plural: 'Campings',
                    create: 'Create camping',
                    edit: 'Edit camping',
                    delete: 'Delete camping'
                },
                name: {
                    label: 'Name'
                },
                status: {
                    label: 'Status'
                },
                email: {
                    label: 'Email'
                },
                phone: {
                    label: 'Phone'
                },
                seasons: {
                    label: 'Season years'
                },
                sarl_name: {
                    label: 'Name'
                },
                sarl_address: {
                    label: 'Address'
                },
                sarl_postalcode: {
                    label: 'Postalcode'
                },
                sarl_city: {
                    label: 'City'
                },
                chain: {
                    label: 'Chain'
                },
                camping_size: {
                    label: 'Camping size'
                },
                siret: {
                    label: 'Siret'
                },
                phone_mobile: {
                    label: 'Mobile phone'
                },
                website: {
                    label: 'Website'
                },
                zoover_url: {
                    label: 'Zoover URL'
                },
                drive_url: {
                    label: 'Drive URL'
                }
            },
            employee: {
                meta: {
                    singular: 'Employee',
                    plural: 'Employees',
                    create: 'Create employee',
                    edit: 'Edit employee',
                    delete: 'Delete employee'
                },
                fullName: {
                    label: 'Name'
                },
                email: {
                    label: 'Emailaddress'
                },
                phone: {
                    label: 'Phone'
                },
                phoneMobile: {
                    label: 'Phone (mobile)'
                },
                phoneHome: {
                    label: 'Phone (home)'
                },
                birthplace: {
                    label: 'Birth place'
                },
                birthday: {
                    label: 'Birth date'
                },
                nationality: {
                    label: 'Nationality'
                },
                street: {
                    label: 'Street'
                },
                houseNumber: {
                    label: 'House number'
                },
                addition: {
                    label: 'addition'
                },
                postalCode: {
                    label: 'Zip code'
                },
                city: {
                    label: 'City'
                },
                country: {
                    label: 'Country'
                },
                firstName: {
                    label: 'Firstname'
                },
                lastName: {
                    label: 'Lastname'
                },
                middleName: {
                    label: 'Prefix'
                },
                initials: {
                    label: 'Initials'
                },
                gender: {
                    label: 'gender',
                    options: {
                        neutral: 'Neutral',
                        male: 'Male',
                        female: 'Female'
                    }
                },
                nationaility: {
                    label: 'Nationality'
                },
                placeOfBirth: {
                    label: 'Birth place'
                },
                transactionId: {
                    label: 'Transaction ID'
                },
                availableFrom: {
                    label: 'Available from'
                },
                availableUntil: {
                    label: 'Available until'
                },
                availableLonger: {
                    label: 'Available longer',
                    description: 'Employee is available for a longer period'
                },
                availableShorter: {
                    label: 'Available shorter',
                    description: 'Employee is available for a shorter period'
                },
                declarationOfIntentType: {
                    label: ''
                },
                declarationOfIntentComment: {
                    label: ''
                },
                clothingSize: {
                    label: 'Clothing size'
                },
                seasons: {
                    label: 'Seasons'
                },
                clothingSend: {
                    label: 'Clothing shipped'
                },
                trainingRefresher: {
                    label: 'Refresment course'
                },
                languageProficiencySummary: {
                    label: 'Description of the French level'
                },
                languageProficiencySummaryFrench: {
                    label: 'Description of the French level (French)'
                },
                educationFrench: {
                    label: 'French summary of education'
                },
                passportReceived: {
                    label: 'Passport received'
                },
                passportExpiresAt: {
                    label: 'Passport expires at'
                },
                registeredSvb: {
                    label: 'Registered at SVB',
                },
                registeredPayrollAdministration: {
                    label: 'Registered Payroll'
                },
                matchingBoard: {
                    label: 'Matching board'
                },
                interestedT4e: {
                    label: 'Interested in T4E'
                },
                payrollT4e: {
                    label: 'Payroll for T4E'
                },
                payrollJ4l: {
                    label: 'Payroll for J4L'

                },
                authorizationReturned: {
                    label: 'Authorization returned'
                },
                substitute: {
                    label: 'Substitute'
                },
                mandateDate: {
                    label: 'Mandate date'
                },
                converted: {
                    label: 'Converted'
                },
                transitioned: {
                    label: 'Transitioned'
                },
                recruiter: {
                    label: 'Recruiter'
                },
                trainingWeekendInvited: {
                    label: 'Invited for trainings weekend',
                    description: 'Has the employee been invited through mail for a trainings weekend'
                },
                trainingWeekendConfirmed: {
                    label: 'Trainingsweekend confirmed',
                    description: 'Is the training confirmed?'

                },
                trainingWeekendPaid: {
                    label: 'Trainingsweekend paid',
                    description: 'Did the employee pay for the training?'
                },
                trainingWeekendGroup: {
                    label: 'Trainingsweekend group'
                },
                reunionDay: {
                    label: 'Invited for the reunion'
                },
                topMeetupInvited: {
                    label: 'Invited for TOP Meetup sent',
                },
                topMeetupConfirmed: {
                    label: 'TOP Meetup confirmed',
                },
                preferredFunction1: {
                    label: 'Prefered function 1'
                },
                preferredFunction2: {
                    label: 'Prefered function 2'
                },
                preferredCountry: {
                    label: 'Prefered country'
                },
                preferredCamping: {
                    label: 'Prefered campsite'
                },
                preferredTeam: {
                    label: 'Prefered team'
                },
                otherPreferences: {
                    label: 'Other preferences'
                },
                level: {
                    label: 'School level'
                },
                frenchTill: {
                    label: 'French till'
                },
                speakingSkills: {
                    label: 'Speaking skills'
                },
                estimationFrench: {
                    label: 'Estimation French'
                },
                trainingRefresher2: {
                    label: 'Refreshment course 2'
                },
                ovbFrench: {
                    label: 'Adopted subject to French level'
                },
                trainingRefresherSend: {
                    label: ''
                },
                estimationGerman: {
                    label: 'Estimation German'
                },
                estimationItalian: {
                    label: 'Estimation Italian'
                },
                estimationSpanish: {
                    label: 'Estimation Spanish'
                },
                estimationEnglish: {
                    label: 'Estimation English'
                },
                workExperienceFrench: {
                    label: 'Work experience (in French)'
                },
                recruitmentChannel: {
                    label: 'Recruitment channel'
                },
                firstSeason: {
                    label: 'First season'
                },
                yearsExperience: {
                    label: 'Years experience'
                },
                formerEmployee: {
                    label: 'Former employee',
                    description: 'Is this a former employee?'
                },
                createdBy: {
                    label: 'Created by'
                },
                experienceSportNl: {
                    label: 'With sport'
                },
                experienceSportFr: {
                    label: 'With sport in French'
                },
                experienceKidsNl: {
                    label: 'With kids'
                },
                experienceKidsFr: {
                    label: 'With kids in French'
                },
                experienceShowNl: {
                    label: 'With shows'
                },
                experienceShowFr: {
                    label: 'With shows in French'
                },
                bsn: {
                    label: 'BSN'
                },
                iban: {
                    label: 'IBAN'
                },
                bic: {
                    label: 'BIC'
                },
                payroll_tax: {
                    label: 'Payroll tax income'
                },
                status: {
                    label: 'Status'
                },
                drivingLicense: {
                    label: 'Driving license'
                },
                vaccinated: {
                    label: 'Clothing received'
                },
                dontContactAnymore: {
                    label: 'Don\'t contact anymore'
                }
            },
            application: {
                remarks: {
                    label: 'Comments'
                },
                date: {
                    label: 'Date'
                },
                time: {
                    label: 'Time'
                },
                week6done: {
                    label: 'Week 6 done',
                    description: 'Are all operations completed after 6 weeks?'
                },
                week12done: {
                    label: 'Week 12 done',
                    description: 'Are all operations completed after 12 weeks?'
                },
                skype: {
                    label: 'Skype',
                    description: 'Is the job interview through Skype?'
                },
            },
            document: {
                doc_url: {
                    label: 'URL'
                },
                filename: {
                    label: 'Filename'
                },
                type: {
                    label: 'Type'
                },
                public: {
                    label: 'Public'
                },
                visibility: {
                    label: 'Visibility'
                },
                createdBy: {
                    label: 'Uploaded by'
                },
                createdAt: {
                    label: 'Uploaded at'
                },
                visibilityEmployee: {
                    label: 'Visible for employee'
                },
                visibilityT4a: {
                    label: 'Visible for TOPAnimation'
                },
                signRequestStatus: {
                    label: 'SignRequest status'
                }
            },
            evaluation: {
                appearance: {
                    label: 'Appearance',
                    description: 'Tell us what you think of the candidate after the interview.'
                },
                independence: {
                    label: 'Independence',
                    description: 'Tell us what you think of the candidate after the interview.'
                },
                flexibility: {
                    label: 'Flexibility',
                    description: 'Tell us what you think of the candidate after the interview.'
                },
                campingType: {
                    label: 'Camping type',
                    description: 'Tell us what you think of the candidate after the interview.'
                },
                notesOther: {
                    label: 'Notes',
                    description: 'Do you need to tell anything else about the employee.'
                },
            },
            education: {
                education: {
                    label: 'Course'
                },
                educationDate: {
                    label: 'Graduated'
                },
            },
            mailtemplate: {
                meta: {
                    singular: 'Mailtemplate',
                    plural: 'Mailtemplates',
                    create: 'Create template',
                    edit: 'Edit template',
                    delete: 'Delete template'
                },

                name: {
                    label: 'Template name'
                },
                locale: {
                    label: 'Locale',
                    options: {
                        nl: 'Dutch',
                        fr: 'French',
                    }
                },
                model: {
                    label: 'Template type',
                    options: {
                        camping: 'camping',
                        employee: 'employee',
                    }
                },
                slug: {
                    label: 'Slug'
                },
                defaultFromEmail: {
                    label: 'Default from email'
                },
                defaultFromName: {
                    label: 'Default from '
                },
                defaultCc: {
                    label: 'Default CC'
                },
                defaultBcc: {
                    label: 'Default BCC'
                },
                defaultSubject: {
                    label: 'Default subject'
                },
                defaultContent: {
                    label: 'Default content'
                },
            },
            status: {
                date: {
                    label: 'Date'
                },
                status: {
                    label: 'Status'
                },
                addedBy: {
                    label: 'Added by'
                }
            },
            employeeNote: {
                date: {
                    label: 'Date'
                },
                note: {
                    label: 'Note'
                },
                addedBy: {
                    label: ' by'
                }
            },
            workExperience: {
                company: {
                    label: 'Company'
                },
                function: {
                    label: 'Function'
                },
                description: {
                    label: 'Description'
                },
            },

            user: {
                meta: {
                    singular: 'User',
                    plural: 'Users',
                    create: 'Create user',
                    edit: 'Edit user',
                    delete: 'Delete user'
                },
                name: {
                    label: 'Name'
                },
                email: {
                    label: 'Emailaddress'
                },
                userRole: {
                    label: 'User role'
                },
                password: {
                    label: 'Password'
                },
                language: {
                    label: 'Language'
                },
                passwordOriginal: {
                    label: 'Your current password'
                },
                passwordNew: {
                    label: 'Your new password',
                    error: 'One or more fields are not filled in correctly. Please check your input and try again.',
                    errors: {
                        minimalChars: 'A good password is at least 8 characters. Add some more.',
                        sameAsOldPassword: 'Your new password should differ from your old one.',
                        confirmationNotEqual: 'Your confirmation is not the same as your new password.'
                    }
                },
                passwordConfirmation: {
                    label: 'Retype your new password'
                },

            },
            emergencyContacts: {
                name: {
                    label: 'Name'
                },
                phoneMobile: {
                    label: 'Phone (mobile)'
                },
                phoneHome: {
                    label: 'Phone (home)'
                }
            },
            personnelProcess: {
                passportReceived: {
                    label: 'Passport received'
                },
                passportExpiresAt: {
                    label: 'Passport expires at'
                },
                isASubstitute: {
                    label: 'Is a substitute'
                },
                substituteDate: {
                    label: 'Substitute date'
                },
                registeredSvb: {
                    label: 'Registered SVB'
                },
                registeredPayroll: {
                    label: 'Registered payroll'
                },
                matchingBoard: {
                    label: 'Matching board'
                },
                interestedT4e: {
                    label: 'Interested in T4E'
                },
                payrollT4e: {
                    label: 'Payroll T4E'
                },
                payrollJ4l: {
                    label: 'Payroll J4L'
                },
                authorizationReturned: {
                    label: 'Authorization returned'
                },
                converted: {
                    label: 'Converted'
                },
                transitioned: {
                    label: 'Transitioned'
                },
                mandateDate: {
                    label: 'Mandate date'
                }
            },
            employeesEditAvailability: {
                availableFrom: {
                    label: 'Available from'
                },
                availableUntil: {
                    label: 'Available until'
                },
                availableLonger: {
                    label: 'Available longer'
                },
                availableShorter: {
                    label: 'Available shorter'
                },
                availability: {
                    label: 'Availability'
                }
            },
            employeesEditTrainingreunion: {
                trainingWeekendInvited: {
                    label: 'Trainingsweekend invited'
                },
                trainingWeekendConfirmed: {
                    label: 'Trainingsweekend confirmed'
                },
                trainingWeekendPaid: {
                    label: 'Trainingsweekend paid'
                },
                trainingWeekendGroup: {
                    label: 'Trainingsweekend group'
                },
                reunionDay: {
                    label: 'Reunion day'
                },
            },
            employeesEditTopMeetup: {
                topMeetupInvited: {
                    label: 'Invitation TOP Meetup sent'
                },
                topMeetupConfirmed: {
                    label: ' TOP Meetup confirmed'
                },
            },
            employeesEditExperience: {
                experienceSportNl: {
                    label: 'Experience sport NL'
                },
                experienceSportFr: {
                    label: 'Experience sport FR'
                },
                experienceKidsNl: {
                    label: 'Experience kids NL'
                },
                experienceKidsFr: {
                    label: 'Experience kids FR'
                },
                experienceShowNl: {
                    label: 'Experience show NL'
                },
                experienceShowFr: {
                    label: 'Experience show FR'
                }
            },
            employeesEditPreferences: {
                preferredFunction1: {
                    label: 'Function 1'
                },
                preferredFunction2: {
                    label: 'Function 2'
                },
                preferredCountry: {
                    label: 'Country'
                },
                preferredCamping: {
                    label: 'Camping',
                    options: {
                        small: 'Small',
                        smallMedium: 'Small/medium',
                        medium: 'Medium',
                        mediumLarge: 'Medium/large',
                        large: 'Large'
                    }
                },
                preferredTeam: {
                    label: 'Team'
                },
                otherPreferences: {
                    label: 'Additional preferences'
                },
            },
            employeeTravel: {
                date: {
                    label: 'Arrival date'
                },
                time: {
                    label: 'Arrival time'
                },
                arrival: {
                    label: 'Arrival city'
                },
                arrivalType: {
                    label: 'Arrival location'
                },
                data: {
                    label: 'Travel data passed on'
                },
                dataProcessed: {
                    label: 'Travel data processed'
                },
                expenses: {
                    label: 'Travel expenses'
                },
                tripNumber: {
                    label: 'Trip number'
                },
            },
            contractSalary: {
                description: {
                    label: 'Salary description'
                },
                salary: {
                    label: 'Salary amount'
                },
                hourWage: {
                    label: 'Hourly wage'
                }
            },
            payruns: {
                meta: {
                    plural: 'payruns',
                    singular: 'payrun',
                },
                period: 'Period',
                processed: 'Processed',
                dateRange: 'Date range',
                retrieve: 'Retrieve'
            }
        },
        buttons: {
            create: 'create',
            creating: 'creating...',
            save: 'save',
            saving: 'saving...',
            cancel: 'cancel',
        }
    }
};

export default messages;
